let navigation = {

    init: () => {

        navigation.name = 'burger__checkbox';
        navigation.navigation = document.querySelectorAll('.' + navigation.name.trim());
        navigation.MainMenu = document.querySelector('.mod_navigation__main');

        navigation.ACTIVECLASS = 'showSubmenu';
        if (navigation.navigation.length > 0) {
            navigation.run();
            navigation.checkHeight();
        }

        return navigation;
    },

    run: () => {

        burger.checked = false;
        burger.addEventListener('change', () => {
            if (burger.checked) {
                navigation.openNavigation();
            } else {
                navigation.closeNavigation();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                navigation.closeNavigation();
            }
        });

        const submenuTogglers = navigation.MainMenu.querySelectorAll('a.submenu');
        const submenuTrail = navigation.MainMenu.querySelectorAll('a.trail.submenu');

        //set initial trail to active
        submenuTrail.forEach((trail) => {
            trail.classList.add(navigation.ACTIVECLASS);
        });

        submenuTogglers.forEach((toggler) => {
            toggler.addEventListener('click', (event) => {
                event.preventDefault();

                const activeSubmenuTogglers = navigation.MainMenu.querySelectorAll("." + navigation.ACTIVECLASS);
                activeSubmenuTogglers.forEach((activeToggler) => {
                    activeToggler.classList.remove(navigation.ACTIVECLASS);
                });

                toggler.classList.add(navigation.ACTIVECLASS);
            });
        });
    },

    checkHeight: () => {

        const level_2 = navigation.MainMenu.querySelectorAll('ul.level_2');
        const nav = navigation.MainMenu.querySelector('nav');

        level_2.forEach((level) => {
            if (level.offsetHeight > nav.offsetHeight) {
                nav.style.height = level.offsetHeight + 60 + 'px';
            }
        });
    },

    closeNavigation: () => {
        document.body.classList.remove('navigation-open');
        burger.checked = false;
    },

    openNavigation: () => {
        document.body.classList.add('navigation-open');
        burger.checked = true;
    }

};

export default navigation.init();